import React, { useEffect, useState } from "react";
import {
  countries,
  countries_en,
} from "../../../../../utils/constants/nameCountry";
import { useCurrentLanguage } from "../../../../../hooks/useCurrentLanguage";
import { getSurveyJSON } from "../../../../../services/jsons";
import { TOOLTIP_STYLE } from "../../../../../utils/constants/graphConfigs";
import CardSurveys from "../../../../reusable/CardSurveys";
import TEXT from "../../../../../utils/text/carousel.json";

export default function Discrimination({ isHomePageGraph, isSmall }) {
  const { language } = useCurrentLanguage();

  const [data, setData] = useState();
  const [isLoading, setIsLoading] = useState(true);
  const [options, setOptions] = useState();
  const [flags, setFlags] = useState([]);

  // Load graph data
  useEffect(() => {
    const getData = async () => {
      const response = await getSurveyJSON("discrimination_mig");

      // Load images
      const flagImages = [];
      const countries = Object.keys(response.data);
      countries.forEach((e) => {
        flagImages.push(require("../../../../../images/flags/" + e + ".png"));
      });

      setFlags(flagImages);
      setData(response);
      setIsLoading(false);
    };

    getData();
  }, []);

  useEffect(() => {
    if (!isLoading && data !== undefined) {
      const countriesList = Object.keys(data.data);
      const pointsList = Object.values(data.data).map(item => item[1]);

      const homeOptions = {
        xAxis: {
          type: 'category',
          data: countriesList,
          name: "País",
          nameLocation: "middle",
          nameGap: 30,
          nameTextStyle: {
            fontFamily: ["Open Sans", "sans-serif"],
            fontSize: 14,
          },
          splitLine: {
            show: false,
          },
        },
        yAxis: {
          name: "Porcentaje (%)",
          nameLocation: "middle",
          nameRotate: 90,
          nameGap: 34,
          nameTextStyle: {
            fontFamily: ["Open Sans", "sans-serif"],
            fontSize: 14,
          },
          splitLine: {
            show: false,
          },
        },
        grid: {
          width: "77%",
          left: "17%",
          height: "80%",
          right: "7%",
          top: "5%",
        },
        series: [
          {
            type: "custom",
            renderItem: (params, api) => {
              const value = api.value(1); // Getting the percentage value
              const coord = api.coord([api.value(0), value]);
              return {
                type: 'group',
                children: [
                  {
                    type: 'image',
                    style: {
                      image: flags[params.dataIndex],
                      x: coord[0] - 20, // Adjust the image position horizontally
                      y: coord[1] - 20, // Adjust the image position vertically
                      width: 40, // Set the image width
                      height: 40 // Set the image height
                    }
                  },
                  {
                    type: 'text',
                    style: {
                      text: `${value.toFixed(1)}%`,
                      x: coord[0] + 25, // Position the text to the right of the flag
                      y: coord[1] - 5, // Align text vertically with the flag
                      fill: '#000', // Text color
                      font: '14px sans-serif' // Text font and size
                    }
                  }
                ]
              };
            },
            data: pointsList.map((point, index) => [index, point]),
          },
        ],
      };

      let options = {
        tooltip: {
          show: true,
          ...TOOLTIP_STYLE,
          valueFormatter: (value) => value + "%",
          formatter: (params) => {
            let elements = [];

            elements.push("<div>");
            elements.push(
              "<span>" +
                (language === "es"
                  ? countries[countriesList[params.dataIndex]]
                  : countries_en[countriesList[params.dataIndex]]) +
                "</span>"
            );
            elements.push(
              "<div>" +
                "Porcentaje:" +
                ": <span>" +
                params.data[1].toFixed(1) +
                "%</span></div>"
            );
            elements.push("</div>");

            return elements.join(" ");
          },
        },
      };

      options = {
        ...homeOptions,
        ...options,
      };

      console.log(options);

      setOptions(options);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoading, language]);

  return (
    <CardSurveys
      isLoading={isLoading}
      graphTitle={TEXT["feelings"]["title"][language]}
      options={options}
    />
  );
}